// nạp @hana/data vào chương trình để bổ sung Entities bên dưới
import type {} from '@hana/data';

/** 7 bước của một chuyến (board Mint-TMS · Mint-Mov-Phone). Chỉ số bước = số bước đã xong. */
export const TRIP_STEPS = ['Đi lấy cont', 'Tại depot', 'Đến kho', 'Rời kho', 'Về cảng', 'Hạ cont', 'Xong'] as const;

/** Mức rủi ro của chuyến trên lưới điều độ. */
export type TripRisk = 'ok' | 'late' | 'p0' | 'done';

/** Chế độ chạy chuyến. */
export type TripMode = 'Nguyên chuyến' | 'Cắt mooc' | 'Ghép chuyến';

/** Một chuyến vận tải (TRF…), rút gọn theo bảng "Điều độ hôm nay" của Mint-TMS. Không có tiền. */
export interface Trip {
  /** số chuyến TRF… */
  id: string;
  /** job gốc */
  jobId: string;
  /** biển đầu kéo; nhà xe ngoài thì tên nhà xe */
  vehicle: string;
  /** tài xế · mooc (nhà xe ngoài: biển xe ngoài) */
  crew: string;
  /** nhà xe sở hữu; 'HANA' = xe nhà */
  owner: string;
  cont: string;
  containerNos: string[];
  mode: TripMode;
  /** số bước đã xong, 0..6 (6 = Xong) */
  step: number;
  /** hạn / mốc kế tiếp, nguyên văn board ("CY Cát Lái 23:59") */
  due: string;
  risk: TripRisk;
  /** người điều độ */
  dispatcher: string;
  /** chip cảnh báo ngắn ("trễ 25′", "ghép chuyến"…) */
  flag: string;
  /** phụ thu ("Neo xe", "Điện lạnh"…), '' = không */
  surcharge: string;
}

export type VehicleKind = 'Truck' | 'Mooc';
export type GpsState = 'run' | 'idle' | 'stop' | 'lost' | 'na';

/** Xe / mooc trong đội xe (TblVehicleList, board Mint-TMS-Fleet). */
export interface Vehicle {
  plate: string;
  kind: VehicleKind;
  model: string;
  gps: GpsState;
  location: string;
  /** chuyến đang chạy, null = không */
  tripId: string | null;
  /** hạn đăng kiểm dd/mm/yyyy */
  inspectionDue: string;
  insurance: string;
  /** khoá kỹ thuật (quá hạn bảo dưỡng) */
  locked: boolean;
  /** ODO km, '—' cho mooc */
  odo: string;
  /** ghi chú cột "Chuyến đang chạy" khi không có chuyến ("rỗng", "đang lưu 52 giờ", "—") */
  tripNote: string;
}

/** Tài xế (đã che tên giữa như golden.json). */
export interface Driver {
  id: string;
  /** tên hiển thị đã che, vd HAI••• */
  name: string;
  vehicle: string | null;
}

export type PlaceKind = 'Cảng' | 'ICD' | 'Depot' | 'Kho' | 'Tuyến' | 'Trạm';

/** Hạn chế xe tại kho (TblWarehouse): giờ cấm tải · tải tối đa · loại xe được vào (rỗng = mọi loại) · đường / khu cấm. */
export interface PlaceRestrict { ban: string[]; ton: number | null; veh: string[]; road: string }

/** Điểm lấy / hạ cont (TblDepot…, board Mint-TMS-Routes · Places). */
export interface Place {
  code: string;
  name: string;
  short: string;
  kind: PlaceKind;
  /** null = chưa có toạ độ */
  lat: number | null;
  lng: number | null;
  /** khu vực hiển thị (vd "Cát Lái · Thủ Đức") */
  area?: string;
  /** bán kính geofence (m) */
  radius?: number | null;
  approved?: boolean;
  /** chỉ Kho: tỉnh · phường / xã · địa chỉ · khách (mã cách nhau dấu cách) · ghi chú · hạn chế xe */
  province?: string;
  ward?: string;
  address?: string;
  customers?: string;
  note?: string;
  restrict?: PlaceRestrict;
  /** giờ hoạt động ("24/7", "06:00–22:00", '' = chưa nhập) */
  hours?: string;
  /** hãng trả / lấy rỗng, dạng "CKL EMC/RF POS/DC" (TblDepotCarrierStock) */
  carriers?: string;
  ecus?: string;
  eport?: boolean;
  /** số tuyến xuất phát */
  routes?: number;
}

export type RouteStatus = 'ok' | 'pend' | 'off';

/** Tuyến TRF (TblTRFRoute, rút gọn). Không có giá. */
export interface TmsRoute {
  code: string;
  type: 'RF' | 'DC';
  /** mã kho khách */
  warehouse: string;
  /** mã điểm trong Place */
  place: string;
  km: number;
  tier: string;
  status: RouteStatus;
  trips: number;
}

declare module '@hana/data' {
  interface Entities {
    trip: Trip;
    vehicle: Vehicle;
    driver: Driver;
    tmsPlace: Place;
    tmsRoute: TmsRoute;
    tmsRouteRow: import('./routes').RouteRow;
  }
}
